import { Radio, RadioGroup } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { LEGACY_RECONCILIATION_VIEW_COUNTRY_ID } from '@features/bankTransactions/constants/legacyReconciliationViewCountryId'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useFormContext } from '../../../../../../../../hooks'
import { ReconciliationView } from '../../../../enums/reconciliationView'
import { OrganizationAccountingFormSchema } from '../../../../utils/organizationAccountingSettingsFormData'

export const ReconciliationViewFormItem = (): ReactElement | null => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { FormItem } = useFormContext<OrganizationAccountingFormSchema>()

  if (organization?.countryId !== LEGACY_RECONCILIATION_VIEW_COUNTRY_ID) {
    return null
  }

  return (
    <FormItem
      name="reconciliationView"
      label={t('settings.organization.accounting.reconciliation_view')}
      render={({ field: { value, onChange, ...rest } }) => (
        <RadioGroup {...rest} value={value} onChange={onChange}>
          <Radio value={ReconciliationView.Classic}>
            {t('settings.organization.accounting.reconciliation_view.classic')}
          </Radio>
          <Radio value={ReconciliationView.Transactions}>
            {t('settings.organization.accounting.reconciliation_view.transactions')}
          </Radio>
        </RadioGroup>
      )}
    />
  )
}
